export default __webpack_public_path__ + "static/media/am_drsalud_mega_menu.8e14c1b7.png";